/**
 * UpdateBattleSettings use case: mutates the draft StageSettings in place.
 * Called from UI whenever the user changes an option.
 */

import type { RenderPort } from "../ports.js";
import { getXpMultiplier, type StageSettings } from "../../domain/stage-settings.js";
import type { FieldId } from "../../domain/types.js";
import type { GameStateView } from "../ports.js";

export type SettingsPatch = Partial<StageSettings>;

export interface UpdateBattleSettingsDeps {
  render: RenderPort;
  getDraftSettings(): StageSettings;
  setDraftSettings(settings: StageSettings): void;
  getPendingFieldId(): FieldId | null;
}

export function createUpdateBattleSettings(deps: UpdateBattleSettingsDeps) {
  return function updateBattleSettings(patch: SettingsPatch): void {
    const current = deps.getDraftSettings();
    const updated: StageSettings = { ...current, ...patch };
    deps.setDraftSettings(updated);
    const fieldId = deps.getPendingFieldId();
    const view: GameStateView = {
      scene: "settings",
      settings: {
        fieldId: fieldId ?? "",
        draft: updated,
        xpMultiplier: getXpMultiplier(updated),
      },
    };
    deps.render.update(view);
  };
}
